import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import TopbarSidebarButton from './TopbarSidebarButton';
import { login, logout, getCurrentUser } from '../../../redux/Auth';
import { pagesRoutes } from '../../../app/Router.js';
import LoginInfo from '../../../components/custom/LoginInfo'
import { getDefaultPath } from '../../../helpers/utils'
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
class TopbarWithNavigation extends PureComponent {

  constructor(props) {
    super(props);

    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(event) {
    this.props.logout();
  }

  render() {
    return (
      <div className='topbar topbar--navigation'>
        <div className="container">
          <div className='topbar__wrapper'>
            <div className='topbar__left'>
              <TopbarSidebarButton />
              {/* <Link className='topbar__logo' to='/home'>FINTRUX BLOG</Link> */}
              <Link className='topbar__logo' to='/home'><img src= {require('../../../img/blog-logo-fintrux.png')} /></Link>
            </div>
            <div className='topbar__right'>
              <nav className='topbar__nav'>
                {/* {
                pagesRoutes
                .filter((v)=>(!v.isAdhoc))
                .map((prop, key) => {
                  if (prop.redirect) {
                    return null;
                  } else {
                    if (prop.short !== "Login") {
                      return (
                        <Link key={key} className='topbar__nav-link' to={prop.path}>
                          <i className={`fa fa-${prop.icon} fs-16 mr-2 fill-fintrux`}></i> {prop.name}</Link>
                      );
                    } else {return null}
                  }
                })
              } */}
                {
                  pagesRoutes
                    .filter((v) => (v.inMenu))
                    .map((obj, i) => {
                      console.log(obj);
                      if (obj.short != "Login") {
                        if (obj.component === null) {
                          return (
                            <a key={i} className='topbar__nav-link' href={obj.path} target="_blank">
                              <i className={`fa fa-${obj.icon} fs-16 mr-2 fill-fintrux`}></i>{obj.menuLabel}</a>
                          )
                        } else {
                          return (
                            <Link key={i} className='topbar__nav-link' to={getDefaultPath(obj.path)}>
                              <i className={`fa fa-${obj.icon} fs-16 mr-2 fill-fintrux`}></i>{obj.menuLabel}</Link>
                          )
                        }
                      }
                      else return null;
                    })
                }
              </nav>
              {/* <LoginInfo {...this.props} /> */}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  user: (state.auth || {}).user,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => (
  bindActionCreators(Object.assign({},
    { login: login },
    { logout: logout },
    { getCurrentUser: getCurrentUser },
  ), dispatch)
)

export default connect(mapStateToProps, mapDispatchToProps)(TopbarWithNavigation);



// WEBPACK FOOTER //
// ./src/pages/_layout/topbar_with_navigation/TopbarWithNavigation.js